@for (template of availableTemplates; track template.id) {
    <button
        mat-icon-button
        class="sidecar-selector__sidecar"
        (click)="selectSidecar(template.layout, template.sidecar)">
        <mat-icon [svgIcon]="template.id" />
    </button>
}
